const initialState = {
  isAuthenticated: false,
  profile: null,
};

export const authenticate = (state, { payload }) => ({
  ...state,
  isAuthenticated: true,
  profile: payload,
});

export const signOut = state => ({
  ...state,
  isAuthenticated: initialState.isAuthenticated,
  profile: initialState.profile,
});

export default initialState;
